<template>
  <div v-test="'drawer-header'">
    <Flex
      direction="column"
      v-if="cashupEnabled"
      :gap="2"
    >
      <Flex equalWidth>
        <BaseCard>
          <Flex
            direction="column"
            :gap="0.5"
          >
            <BaseHeading size="s">{{ $t('drawer.opened_on') }}</BaseHeading>
            <BaseText
              bold
              v-test="'drawer-opened-on'"
            >
              {{ filters.dateTime(drawer.openedOn) }}
            </BaseText>
          </Flex>
        </BaseCard>
        <BaseCard>
          <Flex
            direction="column"
            :gap="0.5"
          >
            <BaseHeading size="s"
              >{{ $t('drawer.opening_amount') }}</BaseHeading
            >
            <BaseHeading
              size="xl"
              v-test="'drawer-opening-amount'"
            >
              {{ filters.currency(drawer.openingAmount) }}
            </BaseHeading>
          </Flex>
        </BaseCard>
        <BaseCard>
          <Flex
            direction="column"
            :gap="0.5"
          >
            <BaseHeading size="s">{{ $t('drawer.current_cash') }}</BaseHeading>
            <BaseHeading
              size="xl"
              v-test="'drawer-current-cash'"
            >
              {{ filters.currency(drawer.expectedTotalCash) }}
            </BaseHeading>
          </Flex>
        </BaseCard>
      </Flex>
      <PageHeader v-if="!hideFilters">
        <template #left>
          <BaseSearch
            v-model="searchValue"
            debounce
          />
        </template>
        <template #right>
          <BaseButton
            :router-link="{ name: 'drawer-transaction' }"
            v-test="'btn-new-transaction'"
          >
            {{ $t('drawer.new_transaction') }}
          </BaseButton>
          <BaseButton
            :router-link="{ name: 'drawer-close' }"
            v-test="'btn-close-drawer'"
          >
            {{ filters.capitalize(
                $t('global.actions.close_item', { item: $t('global.register') })
              ) }}
          </BaseButton>
        </template>
      </PageHeader>
    </Flex>
    <Flex
      direction="column"
      v-else
    >
      <Flex equalWidth>
        <BaseCard>
          <Flex
            direction="column"
            v-test="'drawer-amount-total'"
            :gap="0.5"
          >
            <BaseHeading size="s">{{ $t('drawer.current_cash') }}</BaseHeading>
            <BaseHeading size="xl">
              {{ filters.currency(drawer.total) }}
            </BaseHeading>
          </Flex>
        </BaseCard>
        <BaseCard>
          <Flex
            direction="column"
            v-test="'drawer-amount-today'"
            :gap="0.5"
          >
            <BaseHeading size="s">{{ $t('drawer.balance_today') }}</BaseHeading>
            <BaseHeading size="xl">
              {{ filters.currency(drawer.today) }}
            </BaseHeading>
          </Flex>
        </BaseCard>
        <BaseCard>
          <Flex
            direction="column"
            v-test="'drawer-amount-pin'"
            :gap="0.5"
          >
            <BaseHeading size="s">{{ $t('drawer.debit_today') }}</BaseHeading>
            <BaseHeading size="xl">
              {{ filters.currency(drawer.pin) }}
            </BaseHeading>
          </Flex>
        </BaseCard>
        <BaseCard>
          <Flex
            direction="column"
            v-test="'drawer-amount-credit'"
            :gap="0.5"
          >
            <BaseHeading size="s">{{ $t('drawer.credit_today') }}</BaseHeading>
            <BaseHeading size="xl">
              {{ filters.currency(drawer.creditCard) }}
            </BaseHeading>
          </Flex>
        </BaseCard>
      </Flex>
      <PageHeader v-if="!hideFilters">
        <template #left>
          <BaseSearch
            v-model="searchValue"
            debounce
          />
        </template>
        <template #right>
          <BaseButton
            :router-link="{ name: 'drawer-current-cash' }"
            v-test="'drawer-edit-cash'"
          >
            {{ $t('drawer.edit_cash') }}
          </BaseButton>
          <BaseButton
            :router-link="{ name: 'drawer-transaction' }"
            v-test="'drawer-new-transaction'"
          >
            {{ $t('drawer.new_transaction') }}
          </BaseButton>
        </template>
      </PageHeader>
    </Flex>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import filters from '@/filters';
import PageHeader from '@/modules/PageHeader.vue';
import { useRegisterStore } from '@/modules/register/stores/register';

export default defineComponent({
  components: {
    PageHeader,
  },
  props: {
    search: {
      type: String,
      required: true,
    },
    drawer: {
      type: Object,
      required: true,
    },
    hideFilters: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:search'],
  setup() {
    const { cashupEnabled } = useRegisterStore();
    return {
      filters,
      cashupEnabled,
    };
  },
  computed: {
    searchValue: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit('update:search', value);
      },
    },
  },
});
</script>
